import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { MemberCourse } from "../models/member-course.model";
import { User } from "../models/user.model";

@Injectable({
  providedIn: "root"
})
export class RegmembersService {
  constructor(private http: HttpClient) { }

  getUsersByAreaUnit(
    areaUnitId: number,
    first: number,
    rows: number,
    sortField: string,
    sortOrder: string,
    filters: string
  ): Promise<[User[], number]> {
    let params = {
      first: first.toString(),
      rows: rows.toString()
    };

    if (sortField) {
      params["sortField"] = sortField;
    }
    if (sortOrder) {
      params["sortOrder"] = sortOrder;
    }
    if (filters) {
      params["filters"] = filters;
    }

    return lastValueFrom(this.http
      .get<[User[], number]>(
        `${environment.apiUrl}/regmembers/reports/${areaUnitId}`,
        { params }
      ));
  }

  getUsersBy(
    first: number,
    rows: number,
    sortField: string,
    sortOrder: string,
    filters: string
  ) {
    let params = {
      first: first.toString(),
      rows: rows.toString()
    };

    if (sortField) {
      params["sortField"] = sortField;
    }
    if (sortOrder) {
      params["sortOrder"] = sortOrder;
    }
    if (filters) {
      params["filters"] = filters;
    }

    return lastValueFrom(this.http
      .get<[User[], number]>(`${environment.apiUrl}/regmembers`, {
        params
      })
      );
  }

  getUserBy(membername: string): Promise<User> {
    return lastValueFrom(this.http
      .get<User>(`${environment.apiUrl}/regmembers/${membername}`)
      );
  }

  createRegmem(member: User): Promise<User> {
    return lastValueFrom(this.http
      .post<User>(`${environment.apiUrl}/regmembers`, member)
      );
  }

  updateRegmem(membername: string, member: User): Promise<User> {
    return lastValueFrom(this.http
      .put<User>(`${environment.apiUrl}/regmembers/${membername}`, member)
      );
  }

  deleteRegmem(membername: string): Promise<void> {
    return lastValueFrom(this.http
      .delete<void>(`${environment.apiUrl}/regmembers/${membername}`)
      );
  }

  resetPassword(member: User): Promise<void> {
    return lastValueFrom(this.http
      .post<void>(
        `${environment.apiUrl}/regmembers/${member.membername}/resetPassword`,
        member
      )
      );
  }

  getCoursesBy(membername: string): Promise<MemberCourse[]> {
    return lastValueFrom(this.http
      .get<MemberCourse[]>(`${environment.apiUrl}/regmembers/${membername}/courses`))
      ;
  } 

}
